import React from "react";
import { motion } from "framer-motion";
import PageHero from "../components/PageHero";
import FinalCta from "../components/FinalCta";
import { GALLERY, IMG } from "../lib/content";
import { ArrowUpRight } from "lucide-react";

export default function Gallery() {
  return (
    <main data-testid="gallery-page">
      <PageHero
        eyebrow="Gallery"
        title="Real Sydney stone,"
        italic="really restored."
        subtitle="A selection of recent residential and commercial transformations across Sydney and the Central Coast."
        image={IMG.harborView}
      />

      <section className="py-20 md:py-28 bg-[#F7F4F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7">
          {GALLERY.map((p, i) => (
            <motion.figure
              key={p.title + i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.06 }}
              className="group relative overflow-hidden bg-black aspect-[4/5]"
            >
              <img
                src={p.image}
                alt={`${p.title} — ${p.location}`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/15 to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 p-6 md:p-7 flex items-end justify-between gap-3">
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#E8DAB8]">{p.stone}</div>
                  <div className="mt-2 font-display-bold text-white text-lg md:text-xl tracking-tight">
                    {p.title}
                  </div>
                  <div className="mt-1 text-[12px] text-white/75">{p.location}</div>
                </div>
                <span className="hidden md:inline-flex items-center justify-center w-9 h-9 border border-white/40 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>

      <FinalCta />
    </main>
  );
}
